import { getClaims } from '@/app/api';
import { getStarted } from '@/app/api';
import { getCases } from '@/app/api';

import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IClaim } from '@/pages/main/types';
import { IStartet } from '@/pages/startet/types';
import { ICases } from '@/pages/cases/types';

interface IDataSection<T> {
  data: T[];
  loading: boolean;
}

interface IInitialState {
  krav: IDataSection<IClaim>;
  startet: IDataSection<IStartet>;
  sager: IDataSection<ICases>;
  searchValue: string;
  searchItem: unknown;
}

const initialState: IInitialState = {
  krav: { data: [], loading: false },
  startet: { data: [], loading: false },
  sager: { data: [], loading: false },
  searchValue: '',
  searchItem: {},
};

export const fetchSearchData = createAsyncThunk(
  'search/fetchSearchData',
  async () => {
    const [claimsResponse, startedResponse, casesResponse] = await Promise.all([
      getClaims(),
      getStarted(),
      getCases(),
    ]);
    return {
      claims: claimsResponse.data.filter((item: IClaim) => item !== null),
      started: startedResponse.data,
      cases: casesResponse.data,
    };
  }
);

const searchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    setSearchValue: (state, action: PayloadAction<string>) => {
      state.searchValue = action.payload;
    },
    setSearchItem: (state, action: PayloadAction<unknown>) => {
      state.searchItem = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSearchData.pending, (state) => {
        state.krav.loading = true;
        state.startet.loading = true;
        state.sager.loading = true;
      })
      .addCase(fetchSearchData.fulfilled, (state, action) => {
        state.krav.data = action.payload.claims;
        state.startet.data = action.payload.started;
        state.sager.data = action.payload.cases;
        state.krav.loading = false;
        state.startet.loading = false;
        state.sager.loading = false;
      })
      .addCase(fetchSearchData.rejected, (state) => {
        state.krav.loading = false;
        state.startet.loading = false;
        state.sager.loading = false;
      });
  },
});

export const { setSearchValue, setSearchItem } = searchSlice.actions;
export default searchSlice.reducer;
